export default "__VITE_ASSET__BANB4K0q__"